import ApiService from "@/core/services/ApiService";
import JwtService from "@/core/services/JwtService";
import { Actions, Mutations, APIEndpoints } from "@/store/enums/StoreEnums";
import {
  Module,
  Action,
  Mutation,
  VuexModule,
  config,
} from "vuex-module-decorators";
import store from "@/store/index";

config.rawError = true;

@Module
export default class ProfileModule extends VuexModule {
  @Action
  [Actions.GET_PROFILE]() {
    ApiService.setHeader();
    return new Promise((resolve, reject) => {
      ApiService.get("/attorney/" + APIEndpoints.PROFILE)
        .then(({ data }) => {
          const user = store.getters.currentUser;
          user.name = data.data.info.profile_name;
          user.image = data.data.image;
          user.user_id = data.data.sub_id;
          store.commit(Mutations.SET_USER, user);
          resolve(data);
        })
        .catch((error) => {
          reject(error);
        });
    });
  }

  @Action({ rawError: true })
  [Actions.UPDATE_CONTACT_DETAILS](payload) {
    ApiService.setHeader();
    return new Promise((resolve, reject) => {
      ApiService.put("/attorney/" + APIEndpoints.PROFILE, payload)
        .then((data) => {
          resolve(data);
        })
        .catch((error) => {
          reject(error);
        });
    });
  }

  @Action
  [Actions.UPDATE_BIOGRAPHY](payload) {
    ApiService.setHeader();
    return new Promise((resolve, reject) => {
      ApiService.put("/attorney/" + APIEndpoints.PROFILE + "/details", payload)
        .then((data) => {
          resolve(data);
        })
        .catch((error) => {
          reject(error);
        });
    });
  }

  @Action
  [Actions.GET_USER_TYPE](payload) {
    ApiService.setHeader(payload ? payload.acceptLanguage : null);
    return new Promise((resolve, reject) => {
      ApiService.get(APIEndpoints.USER_TYPE)
        .then((data) => {
          const user = store.getters.currentUser;
          user.name = data.data.data.user.info.profile_name;
          user.image = data.data.data.user.image;
          user.user_id = data.data.data.user.sub_id;
          user.status = data.data.data.user_status;
          user.admin_message = data.data.data.admin_message;
          user.profile_language = data.data.data.settings.language;
          return store.dispatch(Actions.SET_USER_ACTION, {
            user,
            data,
          });
        })
        .then((data) => {
          resolve(data);
        })
        .catch((error) => {
          reject(error);
        });
    });
  }

  @Action({ rawError: true })
  [Actions.UPDATE_SETTINGS](payload) {
    ApiService.setHeader();
    return new Promise((resolve, reject) => {
      ApiService.put(
        `/attorney/${APIEndpoints.PROFILE}/${APIEndpoints.SETTINGS}`,
        payload
      )
        .then((data) => {
          resolve(data);
        })
        .catch((error) => {
          reject(error);
        });
    });
  }

  @Action({ rawError: true })
  [Actions.SUBMIT_TO_REVIEW]() {
    ApiService.setHeader();
    return new Promise((resolve, reject) => {
      ApiService.get(
        `/attorney/${APIEndpoints.PROFILE}/${APIEndpoints.SUBMIT_TO_REVIEW}`
      )
        .then((data) => {
          resolve(data);
        })
        .catch((error) => {
          reject(error);
        });
    });
  }

  @Action({ rawError: true })
  [Actions.GET_ACCOUNT_DETAILS]() {
    ApiService.setHeader();
    return new Promise((resolve, reject) => {
      ApiService.get(
        `/attorney/${APIEndpoints.PAYOUT}/${APIEndpoints.ACCOUNT_DETAILS}`
      )
        .then((data) => {
          resolve(data);
        })
        .catch((error) => {
          reject(error);
        });
    });
  }

  @Action({ rawError: true })
  [Actions.UPDATE_ACCOUNT_DETAILS](payload) {
    ApiService.setHeader();
    return new Promise((resolve, reject) => {
      ApiService.post(
        `/attorney/${APIEndpoints.PAYOUTS}/${APIEndpoints.ACCOUNT_DETAILS}`,
        payload
      )
        .then((data) => {
          resolve(data);
        })
        .catch((error) => {
          reject(error);
        });
    });
  }

  @Action
  [Actions.GENERATE_MFA_QR]() {
    return new Promise((resolve, reject) => {
      ApiService.setHeader();
      ApiService.get(
        `/attorney/${APIEndpoints.PROFILE}/${APIEndpoints.MFA}/${APIEndpoints.GENERATE_QR}`
      )
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  }

  @Action
  [Actions.VERIFY_MFA_TOKEN](payload) {
    return new Promise((resolve, reject) => {
      ApiService.setHeader();
      ApiService.post(
        `/attorney/${APIEndpoints.PROFILE}/${APIEndpoints.MFA}/${APIEndpoints.VERIFY_TOKEN}`,
        payload
      )
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  }

  @Action
  [Actions.ENABLE_MFA_TOKEN]() {
    return new Promise((resolve, reject) => {
      ApiService.setHeader();
      ApiService.get(
        `/attorney/${APIEndpoints.PROFILE}/${APIEndpoints.MFA}/${APIEndpoints.ENABLE_MFA}`
      )
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  }

  @Action
  [Actions.DISABLE_MFA_TOKEN]() {
    return new Promise((resolve, reject) => {
      ApiService.setHeader();
      ApiService.get(
        `/attorney/${APIEndpoints.PROFILE}/${APIEndpoints.MFA}/${APIEndpoints.DISABLE_MFA}`
      )
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  }
}
